/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useCallback, useEffect, useRef, useState } from 'react';

import { makeStyles, MenuItem, Select, useMediaQuery, useTheme } from '@material-ui/core';

import { clearScrollLocks, disableScroll, enableScroll } from '../../utils/scroll';

const useStyles = makeStyles(() => ({
  select: {
    '& .MuiSelect-root ': {
      padding: '0px 4px',
    },
  },
}));

export default ({ url, dimensions, onClose, childResources, title, compactViewer }) => {
  const ref = useRef();
  const theme = useTheme();
  const belowSm = useMediaQuery(theme.breakpoints.down('sm'));
  const classes = useStyles();

  const [selectedResource, setSelectedResource] = useState(null);

  const height = dimensions ? dimensions.height : '75vh';
  let width = '50vw';

  if (dimensions?.width) {
    width = dimensions.width;
  } else if (belowSm) {
    width = '100%';
  }

  useEffect(() => {
    ref.current?.addEventListener('mouseenter', handleMouseEnter);
    ref.current?.addEventListener('mouseleave', handleMouseLeave);
    return () => {
      ref.current?.removeEventListener('mouseenter', handleMouseEnter);
      ref.current?.removeEventListener('mouseleave', handleMouseLeave);
      clearScrollLocks();
    };
  }, []);

  const handleSelectResourceChange = useCallback((event) => {
    if (event.target.value === 'main-resource') {
      setSelectedResource(null);
      return;
    }

    setSelectedResource(event?.target?.value);
  }, []);

  const handleMouseEnter = () => {
    disableScroll(ref.current);
  };

  const handleMouseLeave = () => {
    enableScroll(ref.current);
  };

  const handleCloseIconClick = () => {
    if (!onClose || typeof onClose !== 'function') return;
    onClose();
  };

  return (
    <div>
      {childResources?.length > 0 ? (
        <div style={{ alignItems: 'center', display: compactViewer ? 'flex' : 'block', padding: '4px 8px', textAlign: 'left' }}>
          <p style={{ fontWeight: 'bold', marginBottom: '4px', marginRight: 4, marginTop: 0 }}>Select image to show:</p>

          {childResources?.length > 0 ? (
            <Select
              autoWidth
              value={selectedResource || 'main-resource'}
              onChange={handleSelectResourceChange}
              className={classes.select}
              style={{ border: '1px solid #CCC', borderRadius: '4px', maxWidth: '320px', minWidth: '100px', padding: '0px 4px', width: '100%' }}>
              <MenuItem value="main-resource">{(title || 'MAIN RESOURCE').toUpperCase()} #1</MenuItem>
              {childResources.map((resource, idx) => (
                <MenuItem value={resource} key={`${resource.id}--menu-item`}>
                  {(resource.description || 'No Title').toUpperCase()} #{idx + 2}
                </MenuItem>
              ))}
            </Select>
          ) : null}
        </div>
      ) : null}

      <div
        style={{
          alignItems: 'center',
          backgroundColor: childResources?.length > 0 ? '#00000000' : 'black',
          display: 'flex',
          height,
          justifyContent: 'center',
          minHeight: '280px',
          position: 'relative',
          width,
        }}
        ref={ref}>
        <iframe style={{ border: 'none', height: '99%', width: '99%' }} key={selectedResource?.id || 'ambra-viewer-main'} src={selectedResource?.viewerLink || url} />
        <div onClick={handleCloseIconClick} style={{ background: '#00000000', cursor: 'pointer', height: '58px', position: 'absolute', right: '0%', top: '0%', width: '50px' }} />
      </div>
    </div>
  );
};
